import script from "./PaymentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__